import { render, staticRenderFns } from "./scroll_heatmap.vue?vue&type=template&id=8a361bd2&scoped=true&lang=pug&"
import script from "./scroll_heatmap.vue?vue&type=script&lang=js&"
export * from "./scroll_heatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a361bd2",
  null
  
)

export default component.exports